import { z } from 'zod';

import { ActionRequestStateSchema } from '../enums.js';

import { IsoDateTimeSchema, UuidSchema } from './common.js';

// alert-service action requests (spec §5.5). In-app only; no bulk Done or Decline.

export const ActionRequestSchema = z.object({
  id: UuidSchema,
  alertId: UuidSchema,
  alertCode: z.string(),
  requestedUserId: UuidSchema,
  requestedRole: z.string(),
  requesterUserId: UuidSchema,
  state: ActionRequestStateSchema,
  reason: z.string().nullable(),
  createdAt: IsoDateTimeSchema,
  resolvedAt: IsoDateTimeSchema.nullable(),
});
export type ActionRequest = z.infer<typeof ActionRequestSchema>;

export const RequestsQuerySchema = z.object({
  mine: z
    .enum(['0', '1', 'true', 'false'])
    .default('1')
    .transform((v) => v === '1' || v === 'true'),
});
export type RequestsQuery = z.infer<typeof RequestsQuerySchema>;

export const RequestsResponseSchema = z.object({ requests: z.array(ActionRequestSchema) });
export type RequestsResponse = z.infer<typeof RequestsResponseSchema>;

export const RequestIdParamsSchema = z.object({ id: UuidSchema });

export const RequestDoneSchema = z.object({}).strict();
export const RequestDeclineSchema = z.object({
  reason: z.string().trim().min(1, 'Add a reason for declining.'),
});
export const RequestReassignSchema = z.object({ userId: UuidSchema });

export const RequestActionResponseSchema = z.object({ request: ActionRequestSchema });
export type RequestActionResponse = z.infer<typeof RequestActionResponseSchema>;
